import { clsx } from 'clsx';

/** Hearth logo: a flame over an oven hearth, on the ember brand color. */
export function BrandMark({ size = 28, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden className={clsx('shrink-0', className)}>
      <rect width="32" height="32" rx="8" className="fill-ember-500" />
      <path
        d="M16 6c1.8 3.2 6 5.6 6 10.4A6 6 0 0 1 10 16.4c0-2.3 1.1-3.9 2.4-5.2.2 1.8 1.1 3 2.4 3.4-.4-3.2.1-6 1.2-8.6Z"
        fill="#fff"
      />
      <rect x="8" y="23" width="16" height="2.5" rx="1.25" fill="#fff" />
    </svg>
  );
}
